import * as Actions from './dashboard.actions';
import { DashboardState, DashboardAction } from './dashboard.actions';
import { REQUEST_SUCCESS, REQUEST_FAILED, REQUEST_IN_PROGRESS } from '../../../../types/request-state.model';

const initialState: DashboardState = {

}

export default function Dashboard(state: DashboardState = initialState, action: DashboardAction) {
  switch (action.type) {

    case Actions.GET_DASHBOARD_DATA:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getDashboardDataState: REQUEST_IN_PROGRESS
        } as DashboardState
      );

    case Actions.GET_DASHBOARD_DATA_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getDashboardDataState: REQUEST_SUCCESS
        } as DashboardState
      );

    case Actions.GET_DASHBOARD_DATA_FAIL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getDashboardDataState: REQUEST_FAILED
        } as DashboardState
      );

    case Actions.GET_BROKER_LEADERBOARD_DATA:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getDashboardDataState: REQUEST_IN_PROGRESS
        } as DashboardState
      );

    case Actions.GET_BROKER_LEADERBOARD_DATA_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getDashboardDataState: REQUEST_SUCCESS
        } as DashboardState
      );

    case Actions.GET_BROKER_LEADERBOARD_DATA_FAIL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getDashboardDataState: REQUEST_FAILED
        } as DashboardState
      );

    default:
      return state;
  }
}